import { render, staticRenderFns } from "./tileSleep.vue?vue&type=template&id=1b169188&scoped=true&"
import script from "./tileSleep.vue?vue&type=script&lang=js&"
export * from "./tileSleep.vue?vue&type=script&lang=js&"
import style0 from "./tileSleep.vue?vue&type=style&index=0&id=1b169188&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b169188",
  null
  
)

export default component.exports